enum AdminSectionName {
	ACH_BANK_DEPOSITS = 'AchBankDeposits',
	ADMIN_USERS = 'AdminUsers',
	AGGREGATE_REPORT = 'AggregateReport',
	APPROVE_COMMISSIONS_PAYOUT = 'ApproveCommissionsPayout',
	APPROVE_SURPLUS_PAYOUTS = 'ApproveSurplusPayouts',
	AUTHORIZE_REBATES_AND_CREATE_RBC_BATCH = 'AuthorizeRebatesAndCreateRbcBatch',
	BAA_MINIMUM_ALLOWED_RATES_MANAGEMENT = 'BaaMinimumAllowedRatesManagement',
	BAA_RATING_METHODS = 'BaaRatingMethods',
	BA_AGGREGATE_MANAGEMENT = 'BaAggregateManagement',
	BINDING_AUTHORITY_GEOGRAPHIC_AREA_MANAGEMENT = 'BaGeographicAreaManagement',
	BINDING_AUTHORITY_MANAGEMENT = 'BaManagement',
	CLAIMS = 'Claims',
	COUNTY_FIPS_MANAGEMENT = 'CountyFipsManagement',
	ELIGIBILITY_MESSAGE_PRIORITIES = 'EligibilityMessagePriorities',
	EMAILS = 'Emails',
	ENVIRONMENT_VARIABLES = 'EnvironmentVariables',
	FEMA_DATA_MANAGEMENT = 'FemaDataManagement',
	FINALIZE_REVENUE_STATEMENTS = 'FinalizeRevenueStatements',
	FLAGGED_POLICIES = 'FlaggedPolicies',
	LOSS_SUBMITAL_EMAIL_MANAGEMENT = 'LossSubmitalEmailManagement',
	MANAGE_AFFIDAVIT_DOCUMENTS = 'AffidavitDocuments',
	MANAGE_DILIGENT_DOCUMENTS = 'DiligentDocuments',
	MANAGE_SURPLUS_INSTRUCTIONS = 'SurplusInstructions',
	MANAGE_USER_HELP_TERMS_AND_CONDITIONS = 'UserHelpTermsAndConditions',
	MINIMUM_COST_PER_SQUARE_FOOT = 'MinimumCostPerSquareFoot',
	MINIMUM_COST_PER_SQUARE_FOOT_VERSION = 'Version',
	MUNICH_RE_TRANSACTION_BATCHES = 'MunichReTransactionBatches',
	NON_RENEWALS = 'NonRenewals',
	NOTICES = 'Notices',
	OFFLINE_BANK_DEPOSITS = 'OfflineBankDeposits',
	OFFLINE_PAYMENT_BATCHES = 'OfflinePaymentBatches',
	POLICY_MAP = 'PolicyMap',
	PRODUCERS = 'Producers',
	QUOTE_COMPARE_BATCH_UPLOAD = 'QuoteCompareBatchUpload',
	RATES_BOUNDS_MANAGEMENT = 'RatesBoundsManagement',
	RATES_METHODS_MANAGEMENT = 'RatesMethodsManagement',
	REGIONAL_RATE_SURCHARGES_MANAGEMENT = 'RegionalRateSurchargesManagement',
	RENEWAL_BINDING_AUTHORITIES = 'RenewalBindingAuthorities',
	RENEWAL_RATES = 'RenewalRates',
	REPORTS = 'Reports',
	REVENUE_STATEMENT_BATCHES = 'RevenueStatementBatches',
	STATE_SURPLUS_TEXT = 'StateSurplusText',
	STATE_TAX_RATES = 'StateTaxRates',
	SURPLUS_LINES_BATCHES = 'SurplusLinesBatches',
	SURPLUS_LINE_FILING = 'SurplusLineFiling',
	UNPAID_ENDORSEMENTS = 'UnpaidEndorsements',
	USER_GROUP_PAGE_ACCESS = 'UserGroupPageAccess',
	VERIFY_POLICY_PAYMENTS = 'VerifyPolicyPayments',
}

namespace AdminSectionName {
	export function toEnumList(): AdminSectionName[] {
		let sectionNames: AdminSectionName[] = Object.keys(AdminSectionName)
			.filter((key: string) => key !== AdminSectionName.toEnumList.name)
			.map((key: string) => AdminSectionName[key]);
		return sectionNames;
	}
}

export default AdminSectionName;